import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { isSameDay } from "date-fns";
import { groupingIntervalsByInterval } from "./libraries/GroupingIntervalsByInterval";
import { groupingIntervalsByQuickInterval } from "./libraries/GroupingIntervalsByQuickInterval";
import "../../styles/controls/TimeWindowSelector.css"

const timeIntervals = [
    { name: "1 second", value: 1000 },
    { name: "5 seconds", value: 5000 },
    { name: "10 seconds", value: 10000 },
    { name: "15 seconds", value: 15000 },
    { name: "30 seconds", value: 30000 },
    { name: "1 minute", value: 60000 },
    { name: "2 minutes", value: 120000 },
    { name: "5 minutes", value: 300000 },
    { name: "10 minutes", value: 600000 },
    { name: "15 minutes", value: 900000 },
    { name: "30 minutes", value: 1800000 },
    { name: "1 hour", value: 3600000 },
    { name: "2 hours", value: 7200000 },
    { name: "5 hours", value: 18000000 },
    { name: "10 hours", value: 36000000 },
    { name: "12 hours", value: 43200000 },
    { name: "1 day", value: 86400000 },
    { name: "7 days", value: 604800000 },
    { name: "30 days", value: 2592000000 }
];
const quickIntervals = [
    { name: "Current hour", value: "CURRENT_HOUR"},
    { name: "Current day", value: "CURRENT_DAY"},
    { name: "Current day so far", value: "CURRENT_DAY_SO_FAR"},
    { name: "Current month", value: "CURRENT_MONTH"},
    { name: "Current month so far", value: "CURRENT_MONTH_SO_FAR"},
    { name: "Current quarter", value: "CURRENT_QUARTER"},
    { name: "Current quarter so far", value: "CURRENT_QUARTER_SO_FAR"},
    { name: "Current half year", value: "CURRENT_HALF_YEAR"},
    { name: "Current half year so far", value: "CURRENT_HALF_YEAR_SO_FAR"},
    { name: "Current year", value: "CURRENT_YEAR"},
    { name: "Current year so far", value: "CURRENT_YEAR_SO_FAR"}
];
const aggregations = [
    { name: "Min",value: "MIN"},
    { name: "Max",value: "MAX"},
    { name: "Average",value: "AVG"},
    { name: "Sum",value: "SUM"},
    { name: "Count",value: "COUNT"},
    { name: "None",value: "NONE"},
];
export const getTimeIntervalByValue = (value) =>{
    return timeIntervals.find(t => t?.value === value)?.name || "Unknown";
};
export const getQuickIntervalByValue = (value) =>{
    return quickIntervals.find(q => q?.value === value)?.name || "Unknown";
};

const TimeWindowSelector = ({
    showTimeWindowSelector,setShowTimeWindowSelector,
    dateTimePickerOpen,timeWindow,setTimeWindow}) =>{
    const [selectedTimeWindowTab,setSelectedTimeWindowTab] = useState(0);
    const [selectedRealTimeType,setSelectedRealTimeType] = useState(0);
    const [selectedHistoryType,setSelectedHistoryType] = useState(0);

    const [showRealTimeLastIntervalsBrowser,setShowRealTimeLastIntervalsBrowser] = useState(false);
    const [selectedRealTimeLastInterval,setSelectedRealTimeLastInterval] = useState({ name: "1 minute", value: 60000 });
    
    const [showRealTimeRelativeIntervalsBrowser,setShowRealTimeRelativeIntervalsBrowser] = useState(false);
    const [selectedRealTimeRelativeInterval,setSelectedRealTimeRelativeInterval] = useState({ name: "Current day", value: "CURRENT_DAY"});

    const [showRealTimeAggregationsBrowser,setShowRealTimeAggregationsBrowser] = useState(false);
    const [selectedAggregation,setselectedAggregation] = useState({ name: "Average",value: "AVG"});
    
    const [showRealTimeLastGroupingIntervalsBrowser,setShowRealTimeLastGroupingIntervalsBrowser] = useState(false);
    const [selectedRealTimeLastGroupingInterval,setSelectedRealTimeLastGroupingInterval] = useState({ name: "5 minutes", value: 300000 });
    const [realTimeLastGroupingIntervals,setRealTimeLastGroupingIntervals] = useState([
        { name: "5 minutes", value: 300000 },
        { name: "10 minutes", value: 600000 },
        { name: "15 minutes", value: 900000 },
        { name: "30 minutes", value: 1800000 },
        { name: "1 hour", value: 3600000 },
        { name: "2 hours", value: 7200000 },
        { name: "5 hours", value: 18000000 },
        { name: "10 hours", value: 36000000 },
        { name: "12 hours", value: 43200000 },
        { name: "1 day", value: 86400000 }
    ]);
    const [showRealTimeRelativeGroupingIntervalsBrowser,setShowRealTimeRelativeGroupingIntervalsBrowser] = useState(false);
    const [selectedRealTimeRelativeGroupingInterval,setSelectedRealTimeRelativeGroupingInterval] = useState({ name: "5 minutes", value: 300000 });
    const [realTimeRelativeGroupingIntervals,setRealTimeRelativeGroupingIntervals] = useState([
        { name: "5 minutes", value: 300000 },
        { name: "10 minutes", value: 600000 },
        { name: "15 minutes", value: 900000 },
        { name: "30 minutes", value: 1800000 },
        { name: "1 hour", value: 3600000 },
        { name: "2 hours", value: 7200000 },
        { name: "5 hours", value: 18000000 },
        { name: "10 hours", value: 36000000 },
        { name: "12 hours", value: 43200000 },
        { name: "1 day", value: 86400000 }
    ]);

    const [showHistoryLastIntervalsBrowser,setShowHistoryLastIntervalsBrowser] = useState(false);
    const [selectedHistoryLastInterval,setSelectedHistoryLastInterval] = useState({ name: "1 minute", value: 60000 });

    const [showHistoryRelativeIntervalsBrowser,setShowHistoryRelativeIntervalsBrowser] = useState(false);
    const [selectedHistoryRelativeInterval,setSelectedHistoryRelativeInterval] = useState({ name: "Current day", value: "CURRENT_DAY"});

    const [showHistoryAggregationsBrowser,setShowHistoryAggregationsBrowser] = useState(false);

    const [showHistoryLastGroupingIntervalsBrowser,setShowHistoryLastGroupingIntervalsBrowser] = useState(false);
    const [selectedHistoryLastGroupingInterval,setSelectedHistoryLastGroupingInterval] = useState({ name: "5 minutes", value: 300000 });
    const [historyLastGroupingIntervals,setHistoryLastGroupingIntervals] = useState([
        { name: "5 minutes", value: 300000 },
        { name: "10 minutes", value: 600000 },
        { name: "15 minutes", value: 900000 },
        { name: "30 minutes", value: 1800000 },
        { name: "1 hour", value: 3600000 },
        { name: "2 hours", value: 7200000 },
        { name: "5 hours", value: 18000000 },
        { name: "10 hours", value: 36000000 },
        { name: "12 hours", value: 43200000 },
        { name: "1 day", value: 86400000 }
    ]);
    const [showHistoryRangeGroupingIntervalsBrowser,setShowHistoryRangeGroupingIntervalsBrowser] = useState(false);
    const [selectedHistoryRangeGroupingInterval,setSelectedHistoryRangeGroupingInterval] = useState({ name: "5 minutes", value: 300000 });
    const [historyRangeGroupingIntervals,setHistoryRangeGroupingIntervals] = useState([
        { name: "5 minutes", value: 300000 },
        { name: "10 minutes", value: 600000 },
        { name: "15 minutes", value: 900000 },
        { name: "30 minutes", value: 1800000 },
        { name: "1 hour", value: 3600000 },
        { name: "2 hours", value: 7200000 },
        { name: "5 hours", value: 18000000 },
        { name: "10 hours", value: 36000000 },
        { name: "12 hours", value: 43200000 },
        { name: "1 day", value: 86400000 }
    ]);
    const [showHistoryRelativeGroupingIntervalsBrowser,setShowHistoryRelativeGroupingIntervalsBrowser] = useState(false);
    const [selectedHistoryRelativeGroupingInterval,setSelectedHistoryRelativeGroupingInterval] = useState({ name: "5 minutes", value: 300000 });
    const [historyRelativeGroupingIntervals,setHistoryRelativeGroupingIntervals] = useState([
        { name: "5 minutes", value: 300000 },
        { name: "10 minutes", value: 600000 },
        { name: "15 minutes", value: 900000 },
        { name: "30 minutes", value: 1800000 },
        { name: "1 hour", value: 3600000 },
        { name: "2 hours", value: 7200000 },
        { name: "5 hours", value: 18000000 },
        { name: "10 hours", value: 36000000 },
        { name: "12 hours", value: 43200000 },
        { name: "1 day", value: 86400000 }
    ]);

    const [selectedHistoryRangeStartDate,setSelectedHistoryRangeStartDate] = useState(new Date(new Date().getTime() - 24 * 3600 * 1000));
    const [selectedHistoryRangeEndDate,setSelectedHistoryRangeEndDate] = useState(new Date());

    const [loadingInitialData,setLoadingInitialData] = useState(false);
        
    const isSystem24HourFormat = () =>{
        const formatter = new Intl.DateTimeFormat(undefined,{
            hour: 'numeric'
        });
        const formatted = formatter.format(new Date());
        return !formatted.toLowerCase().includes('am') && !formatted.toLowerCase().includes('pm');
    };
    const isChangesAvailable = () =>{
        const changesAvailable = (
            selectedTimeWindowTab !== timeWindow?.selectedTab ||
            selectedRealTimeType !== timeWindow?.realTime?.realTimeType ||
            selectedRealTimeLastInterval?.value !== timeWindow?.realTime?.timeWindowMs||
            selectedRealTimeRelativeInterval?.value !== timeWindow?.realTime?.quickInterval ||
            (timeWindow?.realTime?.realTimeType === 0 && selectedRealTimeLastGroupingInterval?.value !== timeWindow?.realTime?.interval) ||
            (timeWindow?.realTime?.realTimeType === 1 && selectedRealTimeRelativeGroupingInterval?.value !== timeWindow?.realTime?.interval) ||
            selectedHistoryType !== timeWindow?.history?.historyType ||
            selectedHistoryLastInterval?.value !== timeWindow?.history?.timeWindowMs ||
            selectedHistoryRelativeInterval?.value !== timeWindow?.history?.quickInterval ||
            (timeWindow?.history?.historyType === 0 && selectedHistoryLastGroupingInterval?.value !== timeWindow?.history?.interval) ||
            (timeWindow?.history?.historyType === 1 && selectedHistoryRangeGroupingInterval?.value !== timeWindow?.history?.interval) ||
            (timeWindow?.history?.historyType === 2 && selectedHistoryRelativeGroupingInterval?.value !== timeWindow?.history?.interval) ||
            (timeWindow?.history?.historyType === 1 && selectedHistoryRangeStartDate.getTime() !== timeWindow?.history?.fixedTimeWindow?.startTimeMs) ||
            (timeWindow?.history?.historyType === 1 && selectedHistoryRangeEndDate.getTime() !== timeWindow?.history?.fixedTimeWindow?.endTimeMs) ||
            selectedAggregation?.value !== timeWindow?.aggregation?.type
        );
        return changesAvailable;
    };
    const loadOriginalTimeWindow = () =>{
        setSelectedTimeWindowTab(timeWindow?.selectedTab);
        setSelectedRealTimeType(timeWindow?.realTime?.realTimeType);
        setSelectedRealTimeLastInterval(timeIntervals.find(t => t.value === timeWindow?.realTime?.timeWindowMs));
        setSelectedRealTimeRelativeInterval(quickIntervals.find(t => t.value === timeWindow?.realTime?.quickInterval));
        if(timeWindow?.realTime?.realTimeType === 0) setSelectedRealTimeLastGroupingInterval(
            groupingIntervalsByInterval[timeWindow?.realTime?.timeWindowMs]?.find(t => t.value === timeWindow?.realTime?.interval)
        );
        else if(timeWindow?.realTime?.realTimeType === 1) setSelectedRealTimeRelativeGroupingInterval(
            groupingIntervalsByInterval[timeWindow?.realTime?.timeWindowMs]?.find(t => t.value === timeWindow?.realTime?.interval)
        );
        setSelectedHistoryType(timeWindow?.history?.historyType);
        setSelectedHistoryLastInterval(timeIntervals.find(t => t.value === timeWindow?.history?.timeWindowMs));
        setSelectedHistoryRelativeInterval(quickIntervals.find(t => t.value === timeWindow?.history?.quickInterval));
        if(timeWindow?.history?.historyType === 0) setSelectedHistoryLastGroupingInterval(
            groupingIntervalsByInterval[timeWindow?.history?.timeWindowMs]?.find(t => t.value === timeWindow?.history?.interval)
        );
        else if(timeWindow?.history?.historyType === 1){
            const historyRange = Math.max(1000,timeWindow?.history?.fixedTimeWindow?.endTimeMs - timeWindow?.history?.fixedTimeWindow?.startTimeMs);
            const sortedKeys = Object.keys(groupingIntervalsByInterval).map(Number).sort((a,b) => a - b);
            const previousKey = [...sortedKeys].reverse().find(key => historyRange >= key) ?? sortedKeys[0];
            setSelectedHistoryRangeGroupingInterval(
                groupingIntervalsByInterval[previousKey]?.find(t => t.value === timeWindow?.history?.interval)
            );
        }
        else if(timeWindow?.history?.historyType === 2) setSelectedHistoryRelativeGroupingInterval(
            groupingIntervalsByInterval[timeWindow?.history?.timeWindowMs]?.find(t => t.value === timeWindow?.history?.interval)
        );
        setselectedAggregation(aggregations.find(a => a.value === timeWindow?.aggregation?.type));
        setLoadingInitialData(false);
    };
    const updateTimeWindow = () =>{
        setTimeWindow(prev => ({...prev,
            selectedTab:selectedTimeWindowTab,
            realTime:{
                ...prev?.realTime,
                realTimeType: selectedRealTimeType,
                timeWindowMs: selectedRealTimeLastInterval?.value,
                quickInterval: selectedRealTimeRelativeInterval?.value,
                interval: selectedRealTimeType === 0? selectedRealTimeLastGroupingInterval?.value:selectedRealTimeRelativeGroupingInterval?.value,
            },
            history:{
                ...prev?.history,
                historyType: selectedHistoryType,
                timeWindowMs: selectedHistoryLastInterval?.value,
                fixedTimeWindow: {
                    startTimeMs: selectedHistoryRangeStartDate?.getTime(),
                    endTimeMs: selectedHistoryRangeEndDate?.getTime()
                },
                quickInterval: selectedHistoryRelativeInterval?.value,
                interval: selectedHistoryType === 0? selectedHistoryLastGroupingInterval?.value:selectedHistoryType === 1? selectedHistoryRangeGroupingInterval?.value:selectedHistoryRelativeGroupingInterval?.value,
            },
            aggregation:{
                type: selectedAggregation?.value,
                limit: prev?.aggregation?.limit
            }
        }));
    };
    useEffect(() =>{
        setLoadingInitialData(true);
    },[timeWindow]);
    useEffect(() =>{
        if(loadingInitialData) loadOriginalTimeWindow();
    },[loadingInitialData]);
    useEffect(() => {
            if(loadingInitialData || !selectedRealTimeLastInterval) return;
            const groupings = groupingIntervalsByInterval[selectedRealTimeLastInterval.value];
            if(groupings && groupings.length > 0) setRealTimeLastGroupingIntervals(groupings);
            else return;
            if(!groupings.find(g => g?.value === selectedRealTimeLastGroupingInterval?.value)){
                setSelectedRealTimeLastGroupingInterval(groupings[0]);
            }
    },[selectedRealTimeLastInterval]);
    useEffect(() => {
        if(loadingInitialData || !selectedRealTimeRelativeInterval) return;
        const groupings = groupingIntervalsByQuickInterval[selectedRealTimeRelativeInterval.value];
        if(groupings && groupings.length > 0) setRealTimeRelativeGroupingIntervals(groupings);
        else return;
        if(!groupings.find(g => g?.value === selectedRealTimeRelativeGroupingInterval?.value)){
            setSelectedRealTimeRelativeGroupingInterval(groupings[0]);
        }
    },[selectedRealTimeRelativeInterval]);
    useEffect(() => {
        if(loadingInitialData || !selectedHistoryLastInterval) return;
        const groupings = groupingIntervalsByInterval[selectedHistoryLastInterval.value];
        if(groupings && groupings.length > 0) setHistoryLastGroupingIntervals(groupings);
        else return;
        if(!groupings.find(g => g?.value === selectedHistoryLastGroupingInterval?.value)){
            setSelectedHistoryLastGroupingInterval(groupings[0]);
        }
    },[selectedHistoryLastInterval]);
    useEffect(() =>{
        if(loadingInitialData || !selectedHistoryRangeStartDate || !selectedHistoryRangeEndDate) return;
        const historyRange = Math.max(1000,selectedHistoryRangeEndDate - selectedHistoryRangeStartDate);
        const sortedKeys = Object.keys(groupingIntervalsByInterval).map(Number).sort((a,b) => a - b);
        const previousKey = [...sortedKeys].reverse().find(key => historyRange >= key) ?? sortedKeys[0];
        const groupings = groupingIntervalsByInterval[previousKey];
        if(groupings && groupings.length > 0) setHistoryRangeGroupingIntervals(groupings);
        else return;
        if(!groupings.find(g => g?.value === selectedHistoryRangeGroupingInterval?.value)){
            setSelectedHistoryRangeGroupingInterval(groupings[0]);
        }
    },[selectedHistoryRangeStartDate,selectedHistoryRangeEndDate]);
    useEffect(() => {
        if(loadingInitialData || !selectedHistoryRelativeInterval) return;
        const groupings = groupingIntervalsByQuickInterval[selectedHistoryRelativeInterval.value];
        if(groupings && groupings.length > 0) setHistoryRelativeGroupingIntervals(groupings);
        else return;
        if(!groupings.find(g => g?.value === selectedHistoryRelativeGroupingInterval?.value)){
            setSelectedHistoryRelativeGroupingInterval(groupings[0]);
        }
    },[selectedHistoryRelativeInterval]);
    return(
        <div className="controls-time-window-selector"
            style={{display:showTimeWindowSelector? 'block':'none'}}>
            <div className="time-window-selector-header">
                <button
                    className={selectedTimeWindowTab === 0? 'active':''}
                    onClick={() => setSelectedTimeWindowTab(0)}>Realtime</button>
                <button
                    className={selectedTimeWindowTab === 1? 'active':''}
                    onClick={() => setSelectedTimeWindowTab(1)}>History</button>
            </div>
            {selectedTimeWindowTab === 0? (
                <div className="real-time-time-window">
                    <div className="time-window">
                        <h3>Time window</h3>
                        <div className="real-time-window-type-selector">
                            <button 
                                className={selectedRealTimeType === 0? 'active':''}
                                onClick={() => setSelectedRealTimeType(0)}>Last</button>
                            <button 
                                className={selectedRealTimeType === 1? 'active':''}
                                onClick={() => setSelectedRealTimeType(1)}>Relative</button>
                        </div>
                        {
                            selectedRealTimeType === 0?
                            (
                                <div className="entry-container">
                                    <input
                                        readOnly
                                        value={selectedRealTimeLastInterval?.name || ""}
                                        onFocus={() => setShowRealTimeLastIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() => {setShowRealTimeLastIntervalsBrowser(false)},150)}
                                    />
                                    <div
                                        className={`real-time-intervals-browser ${showRealTimeLastIntervalsBrowser? 'active':''} `}>
                                        {timeIntervals?.map((realTimeLastInterval,index) =>(
                                            <div key={index}
                                                onClick={() => setSelectedRealTimeLastInterval(realTimeLastInterval)}>{realTimeLastInterval.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ):(
                                <div className="entry-container">
                                    <input
                                        readOnly
                                        value={selectedRealTimeRelativeInterval?.name || ""}
                                        onFocus={() => setShowRealTimeRelativeIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() => {setShowRealTimeRelativeIntervalsBrowser(false)},150)}
                                    />
                                    <div
                                        className={`real-time-intervals-browser ${showRealTimeRelativeIntervalsBrowser? 'active':''} `}>
                                        {quickIntervals?.map((quickInterval,index) =>(
                                            <div key={index}
                                                onClick={() => setSelectedRealTimeRelativeInterval(quickInterval)}>{quickInterval.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className="aggregation">
                        <p>Aggregation <span>*</span></p>
                        <input
                            readOnly
                            value={selectedAggregation?.name}
                            onFocus={() => setShowRealTimeAggregationsBrowser(true)}
                            onBlur={() => setTimeout(() =>{setShowRealTimeAggregationsBrowser(false)},150)}
                        />
                        <div className={`aggregations-browser ${showRealTimeAggregationsBrowser? 'active':''}`}>
                            {aggregations?.map((aggregation,index) => (
                                <div key={index}
                                    onClick={() => setselectedAggregation(aggregation)}>{aggregation?.name}</div>
                            ))}
                        </div>
                    </div>
                    <div className="grouping-interval">
                        <p>Grouping interval <span>*</span></p>
                        {
                            selectedRealTimeType === 0?
                            (
                                <>
                                    <input
                                        readOnly
                                        value={selectedRealTimeLastGroupingInterval?.name}
                                        onFocus={() => setShowRealTimeLastGroupingIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() =>{setShowRealTimeLastGroupingIntervalsBrowser(false)},150)}
                                    />
                                    <div className={`grouping-intervals-browser ${showRealTimeLastGroupingIntervalsBrowser? 'active':''}`}>
                                        {realTimeLastGroupingIntervals && realTimeLastGroupingIntervals.map((groupingInterval,index) =>(
                                            <div key={index} onClick={() => setSelectedRealTimeLastGroupingInterval(groupingInterval)}>
                                                {groupingInterval?.name}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ):(
                                <>
                                    <input
                                        readOnly
                                        value={selectedRealTimeRelativeGroupingInterval?.name}
                                        onFocus={() => setShowRealTimeRelativeGroupingIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() =>{setShowRealTimeRelativeGroupingIntervalsBrowser(false)},150)}
                                    />
                                    <div className={`grouping-intervals-browser ${showRealTimeRelativeGroupingIntervalsBrowser? 'active':''}`}>
                                        {realTimeRelativeGroupingIntervals && realTimeRelativeGroupingIntervals.map((groupingInterval,index) =>(
                                            <div key={index} onClick={() => setSelectedRealTimeRelativeGroupingInterval(groupingInterval)}>
                                                {groupingInterval?.name}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            ):(
                <div className="history-time-window">
                    <div className="time-window">
                        <h3>Time window</h3>
                        <div className="history-window-type-selector">
                            <button 
                                className={selectedHistoryType === 0? 'active':''}
                                onClick={() => setSelectedHistoryType(0)}>Last</button>
                            <button 
                                className={selectedHistoryType === 1? 'active':''}
                                onClick={() => setSelectedHistoryType(1)}>Range</button>
                            <button 
                                className={selectedHistoryType === 2? 'active':''}
                                onClick={() => setSelectedHistoryType(2)}>Relative</button>
                        </div>
                        {
                            selectedHistoryType === 0? (
                                <div className="entry-container">
                                    <input
                                        readOnly
                                        value={selectedHistoryLastInterval?.name || ""}
                                        onFocus={() => setShowHistoryLastIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() => {setShowHistoryLastIntervalsBrowser(false)},150)}
                                    />
                                    <div
                                        className={`history-intervals-browser ${showHistoryLastIntervalsBrowser? 'active':''} `}>
                                        {timeIntervals?.map((historyLastInterval,index) =>(
                                            <div key={index}
                                                onClick={() => setSelectedHistoryLastInterval(historyLastInterval)}>{historyLastInterval?.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ):
                            selectedHistoryType === 1? (
                                <div className="dates-range-container">
                                    <div>
                                        <DatePicker
                                            onCalendarOpen={() => dateTimePickerOpen.current = true}
                                            onCalendarClose={() =>setTimeout(() =>dateTimePickerOpen.current = false,100)}
                                            selected={selectedHistoryRangeStartDate}
                                            onChange={(e) => setSelectedHistoryRangeStartDate(e)}
                                            dateFormat={`${isSystem24HourFormat()? 'dd/MM/yyyy h:mm':'dd/MM/yyyy h:mm aa'}`}
                                            showTimeSelect
                                            popperPlacement="bottom-end"
                                            onKeyDown={(e) => e.preventDefault()}
                                            maxDate={selectedHistoryRangeEndDate}
                                            minDate={selectedHistoryRangeEndDate?
                                                new Date(
                                                    selectedHistoryRangeEndDate.getFullYear() - 2,
                                                    selectedHistoryRangeEndDate.getMonth(),
                                                    selectedHistoryRangeEndDate.getDate()
                                                ):undefined
                                            }
                                            minTime={new Date(0, 0, 0, 0, 0)}
                                            maxTime={
                                                selectedHistoryRangeStartDate && selectedHistoryRangeEndDate &&
                                                isSameDay(selectedHistoryRangeStartDate,selectedHistoryRangeEndDate)?
                                                selectedHistoryRangeEndDate:new Date(0, 0, 0, 23, 59)
                                            }
                                            timeIntervals={1}
                                        />
                                    </div>
                                    <div>
                                        <DatePicker
                                            onCalendarOpen={() => dateTimePickerOpen.current = true}
                                            onCalendarClose={() =>setTimeout(() =>dateTimePickerOpen.current = false,100)}
                                            selected={selectedHistoryRangeEndDate}
                                            onChange={(e) => setSelectedHistoryRangeEndDate(e)}
                                            dateFormat={`${isSystem24HourFormat()? 'dd/MM/yyyy h:mm':'dd/MM/yyyy h:mm aa'}`}
                                            showTimeSelect
                                            popperPlacement="bottom-start"
                                            onKeyDown={(e) => e.preventDefault()}
                                            minDate={selectedHistoryRangeStartDate}
                                            minTime={
                                                selectedHistoryRangeStartDate && selectedHistoryRangeEndDate &&
                                                isSameDay(selectedHistoryRangeStartDate,selectedHistoryRangeEndDate)?
                                                selectedHistoryRangeStartDate:new Date(0, 0, 0, 0, 0)
                                            }
                                            maxTime={new Date(0, 0, 0, 23, 59)}
                                            timeIntervals={1}
                                        />
                                    </div>
                                </div>
                            ):
                            selectedHistoryType === 2? (
                                <div className="entry-container">
                                    <input
                                        readOnly
                                        value={selectedHistoryRelativeInterval?.name || ""}
                                        onFocus={() => setShowHistoryRelativeIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() => {setShowHistoryRelativeIntervalsBrowser(false)},150)}
                                    />
                                    <div
                                        className={`history-intervals-browser ${showHistoryRelativeIntervalsBrowser? 'active':''} `}>
                                        {quickIntervals?.map((quickInterval,index) =>(
                                            <div key={index}
                                                onClick={() => setSelectedHistoryRelativeInterval(quickInterval)}>{quickInterval.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ):null
                        }
                    </div>
                    <div className="aggregation">
                        <p>Aggregation <span>*</span></p>
                        <input
                            readOnly
                            value={selectedAggregation?.name}
                            onFocus={() => setShowHistoryAggregationsBrowser(true)}
                            onBlur={() => setTimeout(() =>{setShowHistoryAggregationsBrowser(false)},150)}
                        />
                        <div className={`aggregations-browser ${showHistoryAggregationsBrowser? 'active':''}`}>
                            {aggregations?.map((aggregation,index) => (
                                <div key={index}
                                    onClick={() => setselectedAggregation(aggregation)}>{aggregation?.name}</div>
                            ))}
                        </div>
                    </div>
                    <div className="grouping-interval">
                        <p>Grouping interval <span>*</span></p>
                        {
                            selectedHistoryType === 0? (
                                <>
                                    <input
                                        readOnly
                                        value={selectedHistoryLastGroupingInterval?.name}
                                        onFocus={() => setShowHistoryLastGroupingIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() =>{setShowHistoryLastGroupingIntervalsBrowser(false)},150)}
                                    />
                                    <div className={`grouping-intervals-browser ${showHistoryLastGroupingIntervalsBrowser? 'active':''}`}>
                                        {historyLastGroupingIntervals && historyLastGroupingIntervals.map((groupingInterval,index) =>(
                                            <div key={index} onClick={() => setSelectedHistoryLastGroupingInterval(groupingInterval)}>
                                                {groupingInterval?.name}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ):
                            selectedHistoryType === 1? (
                                <>
                                    <input
                                        readOnly
                                        value={selectedHistoryRangeGroupingInterval?.name}
                                        onFocus={() => setShowHistoryRangeGroupingIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() =>{setShowHistoryRangeGroupingIntervalsBrowser(false)},150)}
                                    />
                                    <div className={`grouping-intervals-browser ${showHistoryRangeGroupingIntervalsBrowser? 'active':''}`}>
                                        {historyRangeGroupingIntervals && historyRangeGroupingIntervals.map((groupingInterval,index) =>(
                                            <div key={index} onClick={() => setSelectedHistoryRangeGroupingInterval(groupingInterval)}>
                                                {groupingInterval?.name}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ):
                            selectedHistoryType === 2? (
                                <>
                                    <input
                                        readOnly
                                        value={selectedHistoryRelativeGroupingInterval?.name}
                                        onFocus={() => setShowHistoryRelativeGroupingIntervalsBrowser(true)}
                                        onBlur={() => setTimeout(() =>{setShowHistoryRelativeGroupingIntervalsBrowser(false)},150)}
                                    />
                                    <div className={`grouping-intervals-browser ${showHistoryRelativeGroupingIntervalsBrowser? 'active':''}`}>
                                        {historyRelativeGroupingIntervals && historyRelativeGroupingIntervals.map((groupingInterval,index) =>(
                                            <div key={index} onClick={() => setSelectedHistoryRelativeGroupingInterval(groupingInterval)}>
                                                {groupingInterval?.name}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ):null
                        }
                    </div>
                </div>
            )}
            <div className="control-buttons-container">
                <button className="cancel-button"
                    onClick={() =>{
                        loadOriginalTimeWindow();
                        setShowTimeWindowSelector(false)
                    }}>Cancel</button>
                <button className={`update-button ${isChangesAvailable()? 'active':''}`}
                    onClick={() => {
                        if(!isChangesAvailable()) return;
                        updateTimeWindow();
                        setShowTimeWindowSelector(false);
                    }}>Update</button>
            </div>
        </div>
    );
};
export default TimeWindowSelector;